module.exports = __webpack_public_path__ + "img/xmasParty21.2dcd1ed6.jpg";